/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  RecordHeartbeatFailureMutationRequest,
  RecordHeartbeatFailureMutationResponse,
  RecordHeartbeatFailurePathParams,
  RecordHeartbeatFailure400,
  RecordHeartbeatFailure404,
  RecordHeartbeatFailure409,
} from '../types/RecordHeartbeatFailure.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getRecordHeartbeatFailureUrl(token: RecordHeartbeatFailurePathParams['token']) {
  const res = { method: 'POST', url: `/heartbeat/${token}/fail` as const };
  return res;
}

/**
 * @description Public endpoint authenticated by the heartbeat token. Opens an incident immediately, without waiting for a missed heartbeat. Repeated failures reuse the open incident and preserve its original details. The next normal heartbeat closes it. Alert delivery uses the existing notification cron.
 * @summary Report an immediate heartbeat failure
 * {@link /heartbeat/:token/fail}
 */
export async function recordHeartbeatFailure(
  token: RecordHeartbeatFailurePathParams['token'],
  data?: RecordHeartbeatFailureMutationRequest,
  config: Partial<RequestConfig<RecordHeartbeatFailureMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    RecordHeartbeatFailureMutationResponse,
    ResponseErrorConfig<RecordHeartbeatFailure400 | RecordHeartbeatFailure404 | RecordHeartbeatFailure409>,
    RecordHeartbeatFailureMutationRequest
  >({ method: 'POST', url: getRecordHeartbeatFailureUrl(token).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
